( function () {
	'use strict';

	function eulaService ( apiService, logger ) {
		function getEula () {
			return apiService.getEula.get()
			.$promise
			.then( function ( resource ) {
				logger.info( 'eula successfully loaded' );

				return resource;
			} );
		}

		function postEula ( credentials ) {
			var userId = credentials.PersonnelId;

			return apiService.postEula( userId ).save( {
				'initials' : credentials.LastName
			} )
			.$promise;
		}

		return {
			'getEula'  : getEula,
			'postEula' : postEula
		};
	}

	angular
		.module( 'app.login' )
		.factory( 'eulaService', eulaService );
} )( );
